import { render, staticRenderFns } from "./FormPage.vue?vue&type=template&id=73841a8b&scoped=true"
import script from "./FormPage.vue?vue&type=script&lang=js"
export * from "./FormPage.vue?vue&type=script&lang=js"
import style0 from "./FormPage.vue?vue&type=style&index=0&id=73841a8b&prod&lang=scss"
import style1 from "./FormPage.vue?vue&type=style&index=1&id=73841a8b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73841a8b",
  null
  
)

export default component.exports